import request from './request'

/**
 * 账单列表分页查询
 * 对应后端接口：GET /api/billing/list
 *
 * @param {object} params - 查询参数
 * @param {number} [params.statusType] - 支付状态（已合并分账状态）：1=未支付, 2=已支付待分账, 3=已支付已分账, 4=逾期未支付
 * @param {number} [params.customerId] - 客户ID
 * @param {number} [params.orderId] - 订单ID
 * @param {string} [params.keyword] - 关键字（客户名称/账单编号）
 * @param {string} [params.dueDateStart] - 应收日期开始，格式：YYYY-MM-DD
 * @param {string} [params.dueDateEnd] - 应收日期结束，格式：YYYY-MM-DD
 * @param {number} [params.page=1] - 页码，从1开始
 * @param {number} [params.size=20] - 每页大小
 * @returns {Promise<object>} 分页结果数据
 */
export function getBillingPage(params) {
  return request.get('/billing/list', { params })
}

/**
 * 账单收款
 * @param {object} data - 请求参数
 * @param {number} data.billingId - 账单ID
 * @param {number} data.paidAmount - 收款金额
 * @param {string} [data.payChannel] - 支付渠道
 */
export function receiveBilling(data) {
  return request.post('/billing/receive', data)
}

/**
 * 预览分账（根据账单ID）
 * @param {number} billingId - 账单ID
 * @returns {Promise<object>} 分账预览数据
 */
export function previewCommission(billingId) {
  return request.get(`/commission/manual/preview-billing/${billingId}`)
}

/**
 * 执行分账
 * @param {object} data - 请求参数
 * @param {number} data.billingId - 账单ID
 */
export function executeCommission(data) {
  return request.post('/commission/manual/execute-billing', data)
}

/**
 * 获取账单详情
 * @param {number} id - 账单ID
 * @returns {Promise<object>} 账单详情
 */
export function getBillingDetail(id) {
  return request.get(`/billing/detail/${id}`)
}

/**
 * 获取账单支付记录
 * @param {number} id - 账单ID
 * @returns {Promise<array>} 支付记录列表
 */
export function getBillingPayments(id) {
  return request.get(`/billing/${id}/payments`)
}

/**
 * 获取账单分账记录
 * @param {number} id - 账单ID
 * @returns {Promise<array>} 分账记录列表
 */
export function getBillingCommissions(id) {
  return request.get(`/billing/${id}/commissions`)
}
